import { h } from 'preact';
import { BaseAnnotation } from '../base_annotation';
import { secondsToTimecode } from 'utilities/formatting';
import { COMPOSITION_TYPES } from 'constants/annotations';
import { accessible, focusable } from 'utilities/accessibility';

export class ChapterMenuBookmarks extends BaseAnnotation {
    onBookmarkClicked = bookmark => e => {
        this.props.onBookmarkClicked(bookmark);
    }

    render() {
        const { CHAPTER_MENU } = COMPOSITION_TYPES;
        const { showThumbnails, parentState, bookmarks, target } = this.props

        return (
            <ul { ...focusable } aria-label="Chapter Menu" role="menu" className="popcorn-contents-list" style={ this.getElementStyles({ elementName: CHAPTER_MENU.LIST, state: this.props.parentState }) }>
                {
                    bookmarks.map((b, i) => (
                        <li
                            key={ `chapter-${i}` }
                            data-thumbnail={ showThumbnails }
                            onClick={ this.onBookmarkClicked(b) }
                            style={ this.getElementStyles({
                                elementName: CHAPTER_MENU.LIST_ITEM,
                                state: this.props.parentState
                            }) }
                        >
                            <span
                                className="popcorn-contents-label"
                                data-gototime={ b.start }
                                style={ this.getElementStyles({ elementName: CHAPTER_MENU.LIST_ITEM_LABEL, state: parentState }) }
                                { ...accessible(this.onBookmarkClicked(b)) }
                            >{ b.content }</span>
                            {showThumbnails && (
                                <div className="thumbnail-time-wrapper" style={this.getBookmarkStyles(b)} data-target-value={target}></div>
                            )}
                            {!showThumbnails && (
                                this.getTime(b)
                            )}
                        </li>
                    ))
                }
            </ul>
        );
    }

    getBookmarkStyles(bookmark) {
        return {
            backgroundImage: `url(${bookmark.thumbnail})`
        }
    }

    getTime(b) {
        const { CHAPTER_MENU } = COMPOSITION_TYPES;
        const { parentState } = this.props;

        return(
            <time
                className="popcorn-contents-time"
                data-gototime={ b.start }
                style={ this.getElementStyles({ elementName: CHAPTER_MENU.LIST_ITEM_TIME, state: parentState }) }
            >{ secondsToTimecode(b.start) }</time>
        )
    }
}